/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {ts_translate} from "../../../common/clientTranslate";

const Wrapper = styled.div`
	display:flex;
	justify-content: ${({spread}) => spread ? 'space-between' : 'flex-end'};
	align-items: center;
	background-color: #4a4a50;
	padding: 8px 17px 11px;
	font-size: 14px;
	color: #fff;
`;

const BarText = styled.span`
	& + span { margin-left: 23px; }
`;

const BlueText = styled.span`
	color: #43abf3;
`;

const Bar = ({
                 task,
                 longNumber,
                 client,
                 spread = false,
                 workgroupview,
             }) => (
    <Wrapper spread={spread}>
        {workgroupview && <BarText>
            <BlueText>
                {ts_translate('Arbeitsgruppenansicht!')}
            </BlueText>
        </BarText>}

        {task.owningTaskErp && <BarText>
            ZSB-Nr.:

            <BlueText>
                &nbsp;{task.owningTaskErp}
            </BlueText>
        </BarText>}
        {task.order_number && <BarText>
            Order-Nr.:
            <BlueText>
                &nbsp;{task.order_number}
            </BlueText>
        </BarText>}
        <BarText>
            {ts_translate('ERP-Nr.')}:

            <BlueText>
                &nbsp;{longNumber}
            </BlueText>
        </BarText>

        <BarText>
            Kunde :

            <BlueText>
                &nbsp;{client}
            </BlueText>
        </BarText>
    </Wrapper>
);

export default Bar;



// WEBPACK FOOTER //
// ./src/components/task/working/bar.js